import React from 'react'

import './CharacterCounter.scss'

export interface CharacterCounterProps {
  currentCount: number
  maxCount: number
  isError?: boolean
  className?: string
}

/**
 * CharacterCounter - Displays current character count against maximum allowed
 * @param currentCount - Current number of characters
 * @param maxCount - Maximum number of characters allowed
 * @param isError - Whether the count exceeds the maximum (shows error styling)
 * @param className - Additional CSS class names
 */
export const CharacterCounter: React.FC<CharacterCounterProps> = ({
  currentCount,
  maxCount,
  isError = false,
  className = '',
}) => {
  const baseClassName = 'character-counter'
  const errorClassName = isError ? `${baseClassName}--error` : ''
  const combinedClassName =
    `${baseClassName} ${errorClassName} ${className}`.trim()

  return (
    <div className={combinedClassName} role="status" aria-live="polite">
      {currentCount}/{maxCount}
    </div>
  )
}

export default CharacterCounter
